import { jsx } from 'react/jsx-runtime';
import { useScreenClass, Box } from '@vp/swan';
import 'react';
import { useHelpSpokeStore } from '../../../../../stores/index.js';
import { RemediationConfirmationAddress } from './RemediationConfirmationAddress.js';

const RemediationConfirmationSideContent=()=>{const screenSize=useScreenClass();const{selectedItems,shippingAddress}=useHelpSpokeStore();const hasReplacement=selectedItems.some(item=>{var _item_remediation;return ((_item_remediation=item.remediation)==null?void 0:_item_remediation.id)==="order-replacement"});if(!["xs","sm"].includes(screenSize)&&hasReplacement&&!!shippingAddress){return jsx(Box,{mt:"8",children:jsx(RemediationConfirmationAddress,{})})}return null};

export { RemediationConfirmationSideContent };
//# sourceMappingURL=RemediationConfirmationSideContent.js.map
